<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="create">

            <v-layout row wrap>
                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-if="! last"
                            v-validate="'required'"
                            v-model="data.request_"
                            :error-messages="errors.collect('data.request_')"
                            label="Sample request"
                            data-vv-name="data.request_"
                            browser-autocomplete="off"
                    ></v-text-field>
                    <v-text-field
                            v-if="last"
                            v-validate="'required'"
                            v-model="data.request_"
                            :error-messages="errors.collect('data.request_')"
                            label="Sample request"
                            data-vv-name="data.request_"
                            :hint="'Last sample request: ' + last"
                            persistent-hint
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-autocomplete
                            v-validate="'required'"
                            v-model="data.client_id"
                            :items="clients"
                            label="Client"
                            item-text="company_name"
                            item-value="id"
                            v-on:change="debouncedRellenarCampos"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.final_client"
                            :error-messages="errors.collect('data.final_client')"
                            label="Final client"
                            data-vv-name="data.final_client"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.contact_person"
                            :error-messages="errors.collect('data.contact_person')"
                            label="Contact person"
                            data-vv-name="data.contact_person"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md6 v-if="! data.client_id">
                    <v-autocomplete
                            v-validate="'required'"
                            :items="direcciones"
                            item-text="direccion_envio"
                            label="Shipping address"
                            v-model="data.shipping_address"
                            data-vv-name="data.shipping_address"
                            :error-messages="errors.collect('data.shipping_address')"
                            clearable
                            browser-autocomplete="off"
                    >
                        <template slot="no-data">
                            <v-list-tile>
                                <v-list-tile-title style="height: 35px;" v-if="! data.client_id">
                                    Select a client.
                                </v-list-tile-title>
                            </v-list-tile>
                        </template>
                    </v-autocomplete>
                </v-flex>

                <v-flex xs6 sm6 md6 v-if="data.client_id">
                    <v-autocomplete
                            v-validate="''"
                            :items="direcciones"
                            item-text="direccion_envio"
                            label="Shipping address"
                            item-value="id"
                            v-model="data.shipping_address"
                            data-vv-name="data.shipping_address"
                            :error-messages="errors.collect('data.shipping_address')"
                            clearable
                            browser-autocomplete="off"
                    ></v-autocomplete>
                    <CreateDireccionEnvioModal :id="data.client_id" v-on:created="crearDireccion"></CreateDireccionEnvioModal>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="''"
                            :items="paises"
                            item-text="name"
                            label="Country"
                            item-value="id"
                            v-model="data.country_id"
                            data-vv-name="data.country_id"
                            :error-messages="errors.collect('data.country_id')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.account_manager"
                            :error-messages="errors.collect('data.account_manager')"
                            label="Account manager"
                            data-vv-name="data.account_manager"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-menu
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <v-text-field
                                v-validate="''"
                                slot="activator"
                                v-model="data.date"
                                :error-messages="errors.collect('data.date')"
                                label="Date"
                                data-vv-name="data.date"
                                readonly
                                browser-autocomplete="off"
                        ></v-text-field>
                        <v-date-picker v-model="data.date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.customer_courier_number"
                            :error-messages="errors.collect('data.customer_courier_number')"
                            label="Customer courier number"
                            data-vv-name="data.customer_courier_number"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="'required'"
                            :items="laboratorios"
                            item-text="name"
                            label="Laboratory"
                            item-value="id"
                            v-model="data.laboratorio_id"
                            data-vv-name="data.laboratorio_id"
                            :error-messages="errors.collect('data.laboratorio_id')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs12 s12 md12>
                    <v-textarea
                            box
                            name="input-7-4"
                            label="Sample request comments"
                            v-model="data.comments"
                            browser-autocomplete="off"
                    ></v-textarea>
                </v-flex>
                <v-flex xs12 s12 md12>
                    <v-btn large color="secondary" class="text--primary" type="submit">Create Sample request</v-btn>
                    <v-btn outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../diccionario';
    import CreateDireccionEnvioModal from './components/CreateDireccionEnvioModal'

    export default {
        data : function() {
            return {
                data : {
                    request_ : '',
                    final_client: '',
                    contact_person: '',
                    customer_code: '',
                    shipping_address: '',
                    account_manager: '',
                    date: '',
                    client_id: '',
                    customer_courier_number: '',
                    comments: '',
                    country_id: null,
                    laboratorio_id: null
                },
                error : false,
                message_error : null,
                clients: null,
                menu: false,
                last: null,
                paises: null,
                direcciones: [],
                laboratorios: []
            }
        },
        created () {
            this.getCountries();
            this.setSectionTitle();
            this.getClients();
            this.getLast();
            this.debouncedRellenarCampos = _.debounce(this.rellenarCampos, 100);
            this.getLaboratorios();
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        methods: {
            getLaboratorios () {
                this.$store.dispatch('getLaboratoriosSelect', {}).then((res) => {
                    this.laboratorios = res.data;
                }).catch((error) => {

                });
            },
            getCountries () {
                this.$store.dispatch('getSelectCountry').then((res) => {
                    this.paises = res.data;
                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Create sample request.'
                });
            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            create : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        if (this.data.shipping_address == 'undefined') {
                            this.data.shipping_address = null;
                        }
                        if (this.data.shipping_address) {
                            this.data.shipping_address = this.data.shipping_address.id;
                        }

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('createSample', this.data).then((res) => {

                            this.$router.push({ name: 'admin.samples.detail', params : { id : res.data.sample_order_id }, query: { model: 'tab-info' } });

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.error_login = true;
                            this.message_error_login = error.data.message;
                        });
                    }
                });

            },
            crearDireccion (direccion) {
                this.$store.dispatch('createClientDireccionesEnvio', direccion).then((res) => {
                    this.rellenarCampos();
                }).catch((error) => {

                });
            },
            rellenarCampos () {
                this.$store.dispatch('getClient', {
                    id: this.data.client_id
                }).then((res) => {
                    this.direcciones = res.data.shipping_address;
                    this.data.shipping_address = res.data.shipping_address_default;
                }).catch((error) => {

                });
            },
            getLast () {
                this.$store.dispatch('getLastSampleOrder', {
                    id: this.data.client_id
                }).then((res) => {
                    this.last = res.data.last_request;

                    this.data.request_ = res.data.sugerencia;

                }).catch((error) => {

                });
            }
        },
        components: {
            CreateDireccionEnvioModal
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/CreateComponent.vue